// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__ABR0N","callout":"Content_callout__f9jEY"};